import { makeStyles } from "@material-ui/core";
const FTLCredentialDetailStyles = makeStyles(() => ({
    root: {},
}));
export default FTLCredentialDetailStyles;
//# sourceMappingURL=FTLCredentialDetailStyles.js.map